import axios from '@/utils/axios';

// Types

export class CreateBookingRequestModel {
	bookedDate!: Date;
	isBooking!: boolean;
	userID!: number;
	serviceID!: number;
}

export class CreateBookingResourceRequestModel {
	bookedDate!: Date;
	bookedDurationInMinutes!: number | null;
	userID!: number;
	serviceID!: number;
}

export class CreateBookingShopRequestModel {
	bookedDate!: Date;
	userID!: number;
	serviceID!: number;
	items!: any[];
}

export class CancelBookingRequestModel {
	bookedDate!: Date;
	userID!: number;
	serviceID!: number;
	hasItems!: boolean;
}

enum BookingPeriod {
	ALL = 0,
	UPCOMING = 1,
	PAST = 2
}

enum BookingSynchronizationState {
	ALL = 0,
	PENDING = 1,
	SYNCHRONIZED = 2
}

export enum BookingActiveState {
	ALL = 0,
	INACTIVE = 1,
	ACTIVE = 2,
	NOT_CANCELLED = 3
}

export enum BookingState {
	WAITING_FOR_CONFIRMATION = 0,
	CONFIRMED = 1,
	WAITING_FOR_CANCELLATION = 2,
	CANCELLED = 3,
}

enum BookingType {
	ALL = 0,
	BOOKING = 1,
	UNBOOKING = 2
}

export enum BookingCategory {
	ALL = 0,
	PASSAGES = 1,
	SHOP = 2,
	RESOURCES = 3
}


/**
 * Réservation de ressources
 */
export class ResourceBookableTimeRange {
	service!: any;
	user!: any;
	startDate!: Date;
	durationInMinutes!: number;
	bookabilityMinimumDurationInMinutes!: number;
	bookabilityMaximumDurationInMinutes!: number;
	bookabilityStepInMinutes!: number;
	isBookable!: boolean;
}

export class ResourceBooking {
	service!: any;
	user!: any;
	startDate!: Date;
	durationInMinutes!: number;
	isEditable!: boolean;
	isReadable!: boolean;
}

// API

export default {
	async getAll(year: number, month: number, day: number | null = null, category = BookingCategory.PASSAGES, allUsers = false): Promise<any[]> {
		return (await axios().get(`/bookings/?month=${month}&year=${year}&day=${day != null ? day : ''}&category=${category}&allUsers=${allUsers}`)).data;
	},

	async getAllUpcoming(category = BookingCategory.PASSAGES, allUsers = false, state = BookingActiveState.ACTIVE): Promise<any[]> {
		return (await axios().get(`/bookings/?period=${BookingPeriod.UPCOMING}&category=${category}&allUsers=${allUsers}&state=${state}`)).data;
	},

	async getAllUnbookingsUpcoming(): Promise<any[]> {
		return (await axios().get(`/bookings/?type=${BookingType.UNBOOKING}&period=${BookingPeriod.UPCOMING}`)).data;
	},

	async getOne(bookingId: number): Promise<any> {
		return (await axios().get(`/bookings/${bookingId}`)).data;
	},

	async create(payload: CreateBookingRequestModel) {
		return (await axios().post(`/bookings/`, payload)).data;
	},

	async createWithCart(payload: CreateBookingShopRequestModel) {
		return (await axios().post(`/bookings/`, payload)).data;
	},

	async createWithDuration(payload: CreateBookingResourceRequestModel) {
		return (await axios().post(`/bookings/`, payload)).data;
	},

	async cancel(payload: CancelBookingRequestModel) {
		return (await axios().patch(`/bookings/cancel`, payload)).data;
	},

	async getAllowedMonthBookableDates(month: number, year: number, category = BookingCategory.PASSAGES): Promise<any[]> {
		return (await axios().get(`/bookings/allowable_dates/?month=${month}&year=${year}&category=${category}`)).data;
	},
	async getAllowedDayBookableTimeRanges(day: number, month: number, year: number, includeBookings: boolean = true): Promise<ResourceBookableTimeRange[]> {
		const data = (await axios().get(`/bookings/allowable_time_ranges/?day=${day}&month=${month}&year=${year}&includeBookings=${includeBookings}`)).data;
		for (const d of data) {
			d.startDate = new Date(Date.parse(d.startDate));
		}
		return data;
	},
};
